<script>
  import API from "../services/Api";

  let query = "";
  let waitingRequest = false;
  let ticketNotFound = false;
  let badRequest = false;
  let stockCreated = false;
  let requestFailed = false;
  let connectionFailed = false;
  let data = {};
  let request = {};
  let stock = {};

  let changeValueChangeONU = () => {
    if (request.changeonu == undefined) {
      request.changeonu = true;
    } else {
      request.changeonu = !request.changeonu;
    }
  };

  let pesquisar = async () => {
    ticketNotFound = false;
    requestFailed = false;
    connectionFailed = false;
    stockCreated = false;
    data = {};
    request = {};
    stock = {};

    if ("" === query) {
      alert("Informe o número de protocolo para realizar a pesquisa");
      return;
    }

    waitingRequest = true;

    await API.get("tickets/" + query)
      .then((response) => {
        data = response.data;
        waitingRequest = false;
        request.protocol = data.protocol;
        request.clientid = data.clientID;
        request.serviceid = data.serviceID;
      })
      .catch((err) => {
        if (err.response) {
          switch (err.response.status) {
            case 404:
              ticketNotFound = true;
              break;
            case 500:
              requestFailed = true;
              break;
          }
        } else {
          connectionFailed = true;
        }
        waitingRequest = false;
      });
  };

  let submit = async () => {
    waitingRequest = true;
    requestFailed = false;
    connectionFailed = false;
    badRequest = false;
    stock = {};

    await API.post("stock", request)
      .then((response) => {
        stock = response.data;
        stockCreated = true;
        waitingRequest = false;
      })
      .catch((err) => {
        if (err.response) {
          switch (err.response.status) {
            case 400:
              badRequest = true;
              break;
            case 500:
              requestFailed = true;
              break;
          }
        } else {
          connectionFailed = true;
        }
        waitingRequest = false;
      });
  };

  function getLocationClient() {
    var id, options;

    function error(err) {
      console.warn("ERROR(" + err.code + "): " + err.message);
    }

    options = {
      enableHighAccuracy: true,
      timeout: 5000,
      maximumAge: 0,
    };

    function showPosition(position) {
      if (
        (position.coords.longitude === request.boxlong &&
          position.coords.latitude === request.boxlat) ||
        (position.coords.longitude === request.spliceboxlong &&
          position.coords.latitude === request.spliceboxlat)
      ) {
        request.clientlong = "Aguarde um momento...";
        request.clientlat = "Aguarde um momento...";
      } else {
        request.clientlong = position.coords.longitude;
        request.clientlat = position.coords.latitude;
        navigator.geolocation.clearWatch(id);
      }
    }

    id = navigator.geolocation.watchPosition(showPosition, error, options);
  }

  function getLocationBox() {
    var id, options;

    function error(err) {
      console.warn("ERROR(" + err.code + "): " + err.message);
    }

    options = {
      enableHighAccuracy: true,
      timeout: 5000,
      maximumAge: 0,
    };

    function showPosition(position) {
      if (
        (position.coords.longitude === request.clientlong &&
          position.coords.latitude === request.clientlat) ||
        (position.coords.longitude === request.spliceboxlong &&
          position.coords.latitude === request.spliceboxlat)
      ) {
        request.boxlong = "Aguarde um momento...";
        request.boxlat = "Aguarde um momento...";
      } else {
        request.boxlong = position.coords.longitude;
        request.boxlat = position.coords.latitude;
        navigator.geolocation.clearWatch(id);
      }
    }

    id = navigator.geolocation.watchPosition(showPosition, error, options);
  }

  function getLocationSpliceBox() {
    var id, options;

    function error(err) {
      console.warn("ERROR(" + err.code + "): " + err.message);
    }

    options = {
      enableHighAccuracy: true,
      timeout: 5000,
      maximumAge: 0,
    };

    function showPosition(position) {
      if (
        (position.coords.longitude === request.clientlong &&
          position.coords.latitude === request.clientlat) ||
        (position.coords.longitude === request.boxlong &&
          position.coords.latitude === request.boxlat)
      ) {
        request.spliceboxlong = "Aguarde um momento...";
        request.spliceboxlat = "Aguarde um momento...";
      } else {
        request.spliceboxlong = position.coords.longitude;
        request.spliceboxlat = position.coords.latitude;
        navigator.geolocation.clearWatch(id);
      }
    }

    id = navigator.geolocation.watchPosition(showPosition, error, options);
  }
</script>

<main>
  <div class="">
    <div class="card-body">
      {#if !waitingRequest}
        <div class="input-group mb-3">
          <input
            type="text"
            placeholder="Informe o protocolo"
            bind:value={query}
            class="form-control"
          />
          <div class="input-group-append">
            <button class="btn btn-outline-secondary" on:click={pesquisar}>
              Ir
            </button>
          </div>
        </div>
      {:else}
        <div class=""><span>Aguarde...</span></div>
      {/if}

      {#if ticketNotFound}
        <div class="text-danger text-center">
          Chamado não encontrado.<br />Verifique as informações e tente
          novamente!
        </div>
      {/if}

      {#if stockCreated}
        <div class="alert alert-success d-flex align-items-center" role="alert">
          <svg class="bi flex-shrink-0 me-2" width="24" height="24"
            ><use xlink:href="#check-circle-fill" /></svg
          >
          <div>Solicitação realizada com sucesso!</div>
        </div>
      {/if}

      <!--{#if data.ticketStatus == "SOLUCIONADO"}
                <div
                    class="alert alert-danger d-flex align-items-center"
                    role="alert"
                >
                    <svg class="bi flex-shrink-0 me-2" width="24" height="24"
                        ><use xlink:href="#exclamation-triangle-fill" /></svg
                    >
                    <div>O chamado em questão já foi encerrado!<br>Não podendo, assim, ser inserida uma baixa de estoque</div>
                </div>
            {/if}-->

      {#if requestFailed}
        <div class="text-danger text-center">
          Não foi possível realizar a pesquisa.<br />
          Tente novamente em instantes!
        </div>
      {/if}

      {#if connectionFailed}
        <div class="text-danger text-center">
          Houve falha de comunicação com o servidor.<br />
          Tente novamente em instantes!
        </div>
      {/if}

      {#if data.clientID && !waitingRequest}
        <div class="accordion" id="accordionExample">
          <div class="card">
            <div class="card-header" id="headingOne">
              <h6
                class="mb-0"
                data-toggle="collapse"
                data-target="#collapseOne"
                aria-expanded="true"
                aria-controls="collapseOne"
              >
                #1 Dados cadastrais
              </h6>
            </div>
            <div
              id="collapseOne"
              class="collapse"
              aria-labelledby="headingOne"
              data-bs-parent="#accordionExample"
            >
              <div class="card-body">
                <p>ID Cliente: {data.clientID}</p>
                <p>Nome: {data.name}</p>
                {#if data.CNPJ}
                  <p>CNPJ: {data.CNPJ}</p>
                  <p>
                    Nome fantasia:
                    {data.companyName}
                  </p>
                {/if}

                {#if data.CPF}
                  <p>CPF: {data.CPF}</p>
                {/if}
                <p>Telefone: {data.phone}</p>
                <p>Celular: {data.cellPhone}</p>
              </div>
            </div>
          </div>
          {#if !stock.id}
            <div class="card">
              <div class="card-header" id="headingTwo">
                <h6
                  class="mb-0"
                  data-toggle="collapse"
                  data-target="#collapseTwo"
                  aria-expanded="true"
                  aria-controls="collapseTwo"
                >
                  #2 Materiais
                </h6>
              </div>
              <div
                id="collapseTwo"
                class="collapse"
                aria-labelledby="headingTwo"
                data-bs-parent="#accordionExample"
              >
                <div class="card-body">
                  <form on:submit|preventDefault={submit}>
                    <div class="mb-3">
                      <!-- svelte-ignore a11y-label-has-associated-control -->
                      <label class="form-label">Marcação inicial (DROP)</label>
                      <input
                        type="number"
                        class="form-control form-control-lg"
                        bind:value={request.dropinitial}
                        placeholder=""
                      />
                    </div>
                    <div class="mb-3">
                      <!-- svelte-ignore a11y-label-has-associated-control -->
                      <label class="form-label">Marcação final (DROP)</label>
                      <input
                        type="number"
                        class="form-control form-control-lg"
                        bind:value={request.dropfinal}
                        placeholder=""
                      />
                    </div>
                    <div class="mb-3">
                      <label for="quantidadeDrop" class="form-label"
                        >Quantidade DROP</label
                      >
                      <input
                        type="number"
                        class="form-control form-control-lg"
                        id="quantidadeDrop"
                        placeholder={request.dropinitial && request.dropfinal
                          ? request.dropinitial - request.dropfinal
                          : ""}
                        disabled
                      />
                    </div>
                    <div class="mb-3">
                      <!-- svelte-ignore a11y-label-has-associated-control -->
                      <label class="form-label">Lote (DROP)</label>
                      <input
                        type="number"
                        class="form-control form-control-lg"
                        bind:value={request.lotedrop}
                        placeholder=""
                      />
                    </div>
                    <div class="mb-3">
                      <!-- svelte-ignore a11y-label-has-associated-control -->
                      <label class="form-label">Latitude (Cliente)</label>
                      <input
                        type="number"
                        class="form-control form-control-lg"
                        placeholder={request.clientlat}
                        required="required"
                        disabled
                      />
                    </div>
                    <div class="mb-3">
                      <!-- svelte-ignore a11y-label-has-associated-control -->
                      <label class="form-label">Longitude (Cliente)</label>
                      <input
                        type="number"
                        class="form-control form-control-lg"
                        placeholder={request.clientlong}
                        required="required"
                        disabled
                      />
                    </div>
                    <button
                      class="btn btn-secondary mb-3"
                      type="button"
                      on:click={getLocationClient}
                      >Obter Localização (Cliente)</button
                    >
                    <div class="mb-3">
                      <!-- svelte-ignore a11y-label-has-associated-control -->
                      <label class="form-label">Latitude (Caixa)</label>
                      <input
                        type="number"
                        class="form-control form-control-lg"
                        placeholder={request.boxlat}
                        required="required"
                        disabled
                      />
                    </div>
                    <div class="mb-3">
                      <!-- svelte-ignore a11y-label-has-associated-control -->
                      <label class="form-label">Longitude (Caixa)</label>
                      <input
                        type="number"
                        class="form-control form-control-lg"
                        placeholder={request.boxlong}
                        required="required"
                        disabled
                      />
                    </div>
                    <button
                      class="btn btn-secondary mb-3"
                      type="button"
                      on:click={getLocationBox}
                      >Obter Localização (Caixa)</button
                    >
                    <div class="mb-3">
                      <!-- svelte-ignore a11y-label-has-associated-control -->
                      <label class="form-label"
                        >Latitude (Caixa de emenda)
                      </label>
                      <input
                        type="number"
                        class="form-control form-control-lg"
                        placeholder={request.spliceboxlat}
                        required="required"
                        disabled
                      />
                    </div>
                    <div class="mb-3">
                      <!-- svelte-ignore a11y-label-has-associated-control -->
                      <label class="form-label"
                        >Longitude (Caixa de emenda)</label
                      >
                      <input
                        type="number"
                        class="form-control form-control-lg"
                        placeholder={request.spliceboxlong}
                        required="required"
                        disabled
                      />
                    </div>
                    <button
                      class="btn btn-secondary mb-3"
                      type="button"
                      on:click={getLocationSpliceBox}
                      >Obter Localização (Caixa de emenda)</button
                    >
                    <div class="mb-3">
                      <label for="quantidadeConectorUPC" class="form-label"
                        >Conectores UPC</label
                      >
                      <input
                        type="number"
                        class="form-control form-control-lg"
                        id="quantidadeConectorUPC"
                        bind:value={request.conectorupc}
                        placeholder="Apenas números"
                      />
                    </div>
                    <div class="mb-3">
                      <label for="quantidadeConectorAPC" class="form-label"
                        >Conectores APC</label
                      >
                      <input
                        type="number"
                        class="form-control form-control-lg"
                        id="quantidadeConectorAPC"
                        bind:value={request.conectorapc}
                        placeholder="Apenas números"
                      />
                    </div>
                    <div class="mb-3">
                      <label for="stretcher" class="form-label">Esticador</label
                      >
                      <input
                        type="number"
                        class="form-control form-control-lg"
                        id="stretcher"
                        bind:value={request.stretcher}
                        placeholder="Apenas números"
                      />
                    </div>
                    <div class="mb-3">
                      <label for="fixed" class="form-label">Fixa fixo</label>
                      <input
                        type="number"
                        class="form-control form-control-lg"
                        id="fixed"
                        bind:value={request.fixed}
                        placeholder="Apenas números"
                      />
                    </div>
                    <div class="mb-3">
                      <label for="clamp" class="form-label">Abraçadeira</label>
                      <input
                        type="number"
                        class="form-control form-control-lg"
                        id="clamp"
                        bind:value={request.clamp}
                        placeholder="Apenas números"
                      />
                    </div>
                    <div class="mb-3">
                      <label for="frictiontape" class="form-label"
                        >Fita isolante</label
                      >
                      <input
                        type="number"
                        class="form-control form-control-lg"
                        id="frictiontape"
                        bind:value={request.frictiontape}
                        placeholder="Apenas números"
                      />
                    </div>
                    <div class="mb-3">
                      <label for="utpnetworkcable" class="form-label"
                        >Cabo de rede UTP</label
                      >
                      <input
                        type="number"
                        class="form-control form-control-lg"
                        id="utpnetworkcable"
                        bind:value={request.utpnetworkcable}
                        placeholder="Apenas números"
                      />
                    </div>
                    <div class="mb-3">
                      <label for="rj45connector" class="form-label"
                        >Conector RJ45</label
                      >
                      <input
                        type="number"
                        class="form-control form-control-lg"
                        id="rj45connector"
                        bind:value={request.rj45connector}
                        placeholder="Apenas números"
                      />
                    </div>
                    <div class="mb-3">
                      <label for="serialONU" class="form-label"
                        >Código do material</label
                      >
                      <input
                        type="text"
                        class="form-control form-control-lg"
                        id="materialcode"
                        bind:value={request.materialcode}
                        placeholder="Informe o código do material"
                      />
                    </div>
                    <div class="mb-3">
                      <input
                        type="checkbox"
                        id="necessitaTrocaONU"
                        on:change={changeValueChangeONU}
                      />
                      <label for="necessitaTrocaONU"
                        >Necessita de troca de ONU</label
                      >
                    </div>
                    {#if request.changeonu}
                      <div class="mb-3">
                        <label for="serialONU" class="form-label"
                          >Serial ONU antiga</label
                        >
                        <input
                          type="text"
                          class="form-control form-control-lg"
                          id="serialONU"
                          bind:value={request.serialoldonu}
                          placeholder="Informe o serial da ONU antiga"
                        />
                      </div>
                    {/if}
                    <div class="mb-3">
                      <label for="serialONU" class="form-label"
                        >Serial ONU</label
                      >
                      <input
                        type="text"
                        class="form-control form-control-lg"
                        id="serialONU"
                        bind:value={request.serialonu}
                        placeholder="Informe o serial"
                      />
                    </div>
                    <div class="mb-3">
                      <label for="modeloONU" class="form-label"
                        >Modelo ONU</label
                      >
                      <select
                        class="form-control form-control-lg"
                        bind:value={request.modelonu}
                        required
                      >
                        <option value="">Selecione...</option>
                        <option>ONT HUAWEI 2.4 WIFI</option>
                        <option>ONT HUAWEI DUAL BAND WIFI</option>
                        <option>ONT100 SC/ APC 1PT GB ETH 1UPLK GPON-FURUKAWA</option>
                        <option>ONU GPON LD1102W SC/ APC 4PT GB ETH 2FXS WIFI-FURUKAWA</option>
                        <option>ONU GPON LD421-21W - FURUKAWA</option>
                        <option>ONU GPON WIFI F670L AC1200 2</option>
                        <option>ONU NOKIA DUAL BAND</option>
                        <option>ONU NOKIA G-140W-H MIMO 2X2 DUAL</option>
                        <option>ONU NOKIA G-240W 2POT/4G WIFI 2.4</option>
                        <option>ONU-FIBERLINK 2111 P - PARKS - WIFI</option>
                        <option>ONU-FIBERLINK 410 PON SC- APC - PARKS - WIFI AC</option>
                        <option>ONU-FIBERLINK FB 2110 PARKS - WIFI (ANTENA INTERNA)</option>
                        <option>ROTEADOR WIFI</option>
                      </select>
                    </div>
                    <div class="mb-3">
                      <label for="modeloONU" class="form-label"
                        >Equipamento</label
                      >
                      <select
                        class="form-control form-control-lg"
                        bind:value={request.equipment}
                      >
                        <option value="">Selecione...</option>
                        <option>PACPON GIGA EPON 8 PORTAS C/PLAQUETA</option>
                        <option>FONTE POE - ENTRADA 88 A 264 VAC-SAIDA 48</option>
                        <option>ROTEADOR WIFI DUAL BAND DE 100 A 200MG</option>
                        <option>ROTEADOR WIFI FI 2.4</option>
                        <option>ROTEADOR WIFI DUAL BAND 50 A 100MG</option>
                      </select>
                    </div>
                    <div class="mb-3">
                      <button
                        class="btn btn-success btn-lg btn-block"
                        type="submit">Finalizar</button
                      >
                    </div>
                  </form>
                </div>
              </div>
            </div>
          {/if}
          {#if stock.id}
            <div class="card">
              <div class="card-header" id="headingThree">
                <h6
                  class="mb-0"
                  data-toggle="collapse"
                  data-target="#collapseThree"
                  aria-expanded="true"
                  aria-controls="collapseThree"
                >
                  #2 Solicitação
                </h6>
              </div>
              <div
                id="collapseThree"
                class="collapse"
                aria-labelledby="headingthree"
                data-bs-parent="#accordionExample"
              >
                <div class="card-body">
                  <p>Protocolo: {stock.protocol || ""}</p>
                  <p>Marcação inicial (DROP): {stock.dropinitial || ""}</p>
                  <p>Marcação final (DROP): {stock.dropfinal || ""}</p>
                  <p>
                    Quantidade DROP: {request.dropinitial && request.dropfinal
                      ? request.dropinitial - request.dropfinal
                      : ""}
                  </p>
                  <p>Lote (DROP): {stock.lotedrop || ""}</p>
                  <p>Latitude (Cliente): {stock.clientlat || ""}</p>
                  <p>Longitude (Cliente): {stock.clientlong || ""}</p>
                  <p>Latitude (Caixa): {stock.boxlat || ""}</p>
                  <p>Longitude (Caixa): {stock.boxlong || ""}</p>
                  <p>
                    Conector UPC: {stock.conectorupc || ""}
                  </p>
                  <p>
                    Conector APC: {stock.conectorapc || ""}
                  </p>
                  <p>Esticador: {stock.stretcher || ""}</p>
                  <p>Fixa fixo: {stock.fixed || ""}</p>
                  <p>Abraçadeira: {stock.clamp || ""}</p>
                  <p>Fita isolante: {stock.frictiontape || ""}</p>
                  <p>Cabo de rede UTP: {stock.utpnetworkcable || ""}</p>
                  <p>Conector RJ45: {stock.rj45connector || ""}</p>
                  <p>
                    Serial ONU antiga: {stock.serialoldonu || ""}
                  </p>
                  <p>Serial ONU: {stock.serialonu || ""}</p>
                  <p>Modelo ONU: {stock.modelonu || ""}</p>
                </div>
              </div>
            </div>
          {/if}
        </div>
      {/if}
    </div>
  </div>
</main>
